import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import { useAuth } from '../../context/AuthContext';
import PasswordFields from '../../components/PasswordFields';
import Icon from '../../components/Icon';

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { acceptInvite } = useAuth();
  const [error, setError] = useState(null);

  const token = params.get('token');
  const email = params.get('email');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { password: '', confirmPassword: '' } });

  if (!token || !email) {
    return (
      <div className="auth-shell">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div
            className="auth-logo"
            style={{ margin: '0 auto 18px', background: 'var(--danger-bg)', color: 'var(--danger-fg)', boxShadow: 'none' }}
          >
            <Icon name="link_off" style={{ fontSize: 24 }} />
          </div>
          <h1 className="auth-title">This invitation is not valid</h1>
          <p className="auth-sub">Ask a platform administrator to send you a new invitation.</p>
          <Link to="/login" className="btn-ghost" style={{ width: '100%', justifyContent: 'center' }}>
            Back to sign in
          </Link>
        </div>
      </div>
    );
  }

  const onSubmit = async (values) => {
    setError(null);
    try {
      // Accepting an invitation signs the new member straight in.
      await acceptInvite({
        token,
        email,
        password: values.password,
        confirmPassword: values.confirmPassword,
      });
      toast.success('Your account is active. Welcome aboard.');
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <img className="auth-logo-img" src="/photos/logo.png" alt="My Desi Guru" />
        <h1 className="auth-title">Activate your account</h1>
        <p className="auth-sub">Choose a password for {email}</p>

        {error && (
          <div
            role="alert"
            style={{
              background: 'var(--danger-bg)',
              color: 'var(--danger-fg)',
              padding: '11px 14px',
              borderRadius: 'var(--radius)',
              fontSize: 13,
              fontWeight: 600,
              marginBottom: 18,
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <PasswordFields register={register} errors={errors} watch={watch} />

          <button type="submit" className="btn-brand" style={{ width: '100%', justifyContent: 'center' }} disabled={isSubmitting}>
            {isSubmitting && <span className="spinner" />}
            Activate account
          </button>
        </form>
      </div>
    </div>
  );
}
